import { useTranslation } from 'react-i18next';
import { PmsPasswordDialog } from './PmsWorkParts.js';

/**
 * Complete & Report imzası (K7): açık onay adımı, parola yalnız şirket ayarı açıkken (ADR 0075);
 * raporlanan kayıt değişmez [NR496 4.5.3f].
 */
export function ReportDialog({
  opened,
  woNo,
  onClose,
  onConfirm,
}: {
  opened: boolean;
  woNo: string;
  onClose: () => void;
  /** Parola yalnız girildiyse. */
  onConfirm: (password: string | undefined) => Promise<void>;
}) {
  const { t } = useTranslation();
  return (
    <PmsPasswordDialog
      opened={opened}
      title={t('pms.work.detail.reportTitle')}
      body={t('pms.work.detail.reportBody', { wo: woNo })}
      reason="none"
      reauthKind="pms_work_record"
      confirmLabel={t('pms.work.detail.complete')}
      onClose={onClose}
      onConfirm={async ({ password }) => {
        await onConfirm(password);
        return null;
      }}
    />
  );
}
